import { GButton } from 'components/atom/button';
import SearchMolecule, {
  GButtonBoxCum,
  SearchItemWrap,
  SearchWrap,
  UnHiddenSearchWrap,
} from 'components/common/SearchMolecule';
import searchImage from 'components/asset/images/Search.svg';
import RecycleB from 'components/asset/images/RecycleB.svg';
import GButtonLayout from 'components/molecule/GbuttonLayout';
import { SubTitleBtnArea } from 'components/organism/SubTitleBtnArea';
import SubTitleBox from 'components/molecule/SubTitleBox';
import { GContentGrid } from 'components/layouts/GContentGrid';
import { AgGridReact } from 'ag-grid-react';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useColumnDefsForApprovalList } from './hooks/useMemberList';
import { useLoading } from 'components/process/Loading';
import { useMessageBar } from 'components/process/MessageBar';
import { getMemberList } from 'apis/vars/member/Member';
import { MemberVO } from 'models/vars/member/MemberVO';
import { CommonCode } from 'models/admin/CommonCode';
import { getCommonCodes } from 'apis/admin/CommonCode';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import { CellClickedEvent } from 'ag-grid-community';
import SearchMoleculeVars from 'components/vars/common/SearchMoleculeVars';
import EmptyState from 'components/atom/emptyState';
import dayjs from 'dayjs';
import { NoticeModal } from 'pages/admin/noticemanagement/NoticeModal';
import { NoticePostDetail } from 'models/admin/Notice';
import { findNoticePopupPost } from 'apis/admin/Notice';
import { PaginationRequest } from 'models/common/Pagination';
import { GPagination, PaginationRef } from 'components/layouts/GPagination';

const MemberListPage = () => {
  const { t } = useTranslation();
  // MBR_PSG_STAT_CD
  const [statCdList, setStatCdList] = useState<CommonCode[]>([]);

  interface RespMemberVO {
    vdcpCd: string;
    vdcpErpNm: string;
    vdcpNm: string;
    vdcpMgrNm: string;
    vdcpMgrEmal: string;
    soprMgrCopCd: string;
    soprMgrNm: string;
    mbrPsgStatCd: string;
    mbrPsgStatCdNm: string;
    dataInsDtm: string;
    regReqDt: string;
    regReqDtSt?: string;
    regReqDtEnd?: string;
  }

  const InitMemberListGrid: RespMemberVO = {
    vdcpCd: '',
    vdcpErpNm: '',
    vdcpNm: '',
    vdcpMgrNm: '',
    vdcpMgrEmal: '',
    soprMgrCopCd: '',
    soprMgrNm: '',
    mbrPsgStatCd: '',
    mbrPsgStatCdNm: '',
    dataInsDtm: '',
    regReqDt: '',
    regReqDtSt: '',
    regReqDtEnd: '',
  };

  const [noticePopups, setNoticePopups] = useState<NoticePostDetail[]>([]);

  const [memberList, setMemberList] = useState<RespMemberVO[]>([InitMemberListGrid]);

  const [totalCount, setTotalCount] = useState<number>(0);
  const paginationRef = useRef<PaginationRef>(null);
  const [pageNo, setPageNo] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(30);
  const [pageSizeList, setPageSizeList] = useState<any>([]);
  const [pageSizeOption, setPageSizeOption] = useState<string>('1');

  interface ReqMemberVO extends PaginationRequest {
    mbrPsgStatCd?: string;
    soprMgrNm?: string;
    vdcpErpNm?: string;
    vdcpNm?: string;
    vdcpCd?: string;
    vdcpMgrNm?: string;
    vdcpMgrEmal?: string;
    soprMgrCopCd?: string;
    dataInsDtm?: string;
    regReqDt?: string;
    regReqDtSt?: string;
    regReqDtEnd?: string;
  }

  const [searchParams, setSearchParams] = useState<ReqMemberVO>({
    mbrPsgStatCd: 'ALL',
    soprMgrNm: '',
    vdcpErpNm: '',
    vdcpNm: '',
    vdcpCd: '',
    vdcpMgrNm: '',
    vdcpMgrEmal: '',
    soprMgrCopCd: '',
    dataInsDtm: '',
    regReqDt: '',
    regReqDtSt: '',
    regReqDtEnd: '',
    pageSize: '30',
    start: '0',
  });

  const getPageSizeData = useCallback(() => {
    // 15 제외 하기 위해서 filter 추가
    getCommonCodes('PG_ROW_CNT_CD').then((result: CommonCode[]) => {
      const resList = result
        .filter((item) => 'Y' === item.useYn)
        .filter((item) => '15' !== item.cmnCd)
        .map((item) => item.cmnCdNm)
        .filter(Boolean);
      setPageSizeList(resList);
    });
  }, []);

  async function getNoticePopupPosts() {
    const noticePopupPosts = await findNoticePopupPost();
    noticePopupPosts && setNoticePopups(noticePopupPosts);
  }

  const handleCrtDateChange = (newDate, id) => {
    handleDateRangeChange(newDate, id, 'regReqDt', 'YYYYMMDD');
  };

  const handleDateRangeChange = (newDate, id, key, format) => {
    const newParams = {};
    if (id === 'end') {
      newParams[key + 'End'] = newDate.format(format);

      if (searchParams[key + 'St'] === '' || newDate.isBefore(dayjs(searchParams[key + 'St'])))
        newParams[key + 'St'] = newDate.format(format);

      setSearchParams((prev) => {
        return {
          ...prev,
          ...newParams,
        };
      });
    } else if (id === 'start') {
      newParams[key + 'St'] = newDate.format(format);

      if (searchParams[key + 'End'] === '' || newDate.isAfter(dayjs(searchParams[key + 'End'])))
        newParams[key + 'End'] = newDate.format(format);

      setSearchParams((prev) => {
        return {
          ...prev,
          ...newParams,
        };
      });
    }
  };

  const gridApiRef = useRef<any>(null);
  const { defaultColDef, colDefs } = useColumnDefsForApprovalList();
  const { openLoading } = useLoading();
  const { openMessageBar } = useMessageBar();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    getNoticePopupPosts();
    getPageSizeData();
  }, []);

  /**
   * Init
   */
  useEffect(() => {
    getCommonCodes('MBR_PSG_STAT_CD').then((result: CommonCode[]) => {
      const tmpAll = {
        cmnCd: 'ALL',
        cmnCdNm: t('com.label.00511', '__전체'),
      };
      result.unshift(tmpAll);
      setStatCdList(result);
    });
    if (location?.state?.backList === 'Y') {
      const backPageNo = location.state.pageNo;
      const backPageSize = location.state.pageSize;
      const backSearchParams = location.state.searchParams;
      paginationRef.current?.setSelectNo(backPageNo);
      paginationRef.current?.setPageSize(backPageSize);
      setSearchParams({ ...backSearchParams });
      setPageNo(backPageNo);
      setPageSize(backPageSize);

      search(true, backSearchParams);
      return;
    }
    search(false, searchParams);
  }, []);

  useEffect(() => {
    //
    if (location?.state?.backList === 'Y') {
      const option = pageSizeList.findIndex((i) => i === String(pageSize ?? '30'));
      setPageSizeOption(String(Number(option) + 1));
    }
  }, [pageSizeList]);

  /**
   * 인풋 컴포넌트 체인지 이벤트
   * @param e
   */
  const handleChangeSearchParams = (e, id) => {
    console.log('아이디 : ', id, e.target.value);
    setSearchParams((prev) => {
      return { ...prev, [id]: e.target.value };
    });
  };

  const handleClickSearchParamInit = () => {
    setSearchParams({
      mbrPsgStatCd: 'ALL',
      soprMgrNm: '',
      vdcpErpNm: '',
      vdcpNm: '',
      vdcpCd: '',
      vdcpMgrNm: '',
      vdcpMgrEmal: '',
      soprMgrCopCd: '',
      dataInsDtm: '',
      regReqDt: '',
      regReqDtSt: '',
      regReqDtEnd: '',
    });
  };

  const handleClickSearch = () => {
    console.log('조회', searchParams);
    search(false, searchParams);
  };

  function search(isPage: boolean, condition: ReqMemberVO) {
    const param = condition ?? searchParams;
    const start = isPage ? param.start : '0';
    getMemberList({ ...param, start } as MemberVO)
      .then((data) => {
        if (data) {
          const list = data.list as RespMemberVO[];
          setMemberList(() => {
            return [...list];
          });
          setTotalCount(() => {
            return data.totalCount;
          });
          if (!isPage) {
            setPageNo(1);
            paginationRef.current?.setSelectNo(1);
          }
        }
      })
      .catch(handleError);
  }

  const handleError = (e: Error) => {
    openLoading(false);
    openMessageBar('error', e.message);
  };

  const handlePageSize = (value: number) => {
    paginationRef.current?.setPageSize(value);
    setPageSize(value);
    setPageNo(1);
    const condition = {
      ...searchParams,
      start: '0',
      pageSize: String(value),
    };
    setSearchParams({ ...condition });
    search(true, { ...condition });
  };

  const handlePageNoClick = (pageNo: number) => {
    const condition = {
      ...searchParams,
      start: String((pageNo - 1) * pageSize),
    };
    setSearchParams({ ...condition });
    setPageNo(pageNo);
    search(true, { ...condition });
  };

  return (
    <>
      <SearchWrap>
        <UnHiddenSearchWrap>
          <SearchItemWrap>
            <SearchMoleculeVars
              labelTitle={t('com.label.00506', '처리상태')}
              searchWidth="50%"
              radio2Id="mbrPsgStatCd"
              type="radio2"
              radio2Value={searchParams.mbrPsgStatCd || ''}
              radio2ValueKey="cmnCd"
              radio2LabelKey="cmnCdNm"
              radio2DefaultValue={searchParams.mbrPsgStatCd}
              // radio2Option={statCdList}
              radio2Option={[
                { cmnCd: 'ALL', cmnCdNm: t('com.label.00511', '__전체') },
                { cmnCd: 'R', cmnCdNm: t('com.label.00299', '__처리중') },
                { cmnCd: 'C', cmnCdNm: t('com.label.00296', '__승인완료') },
              ]}
              onChange={(e) => {
                handleChangeSearchParams(e, 'mbrPsgStatCd');
              }}
            />
            <SearchMolecule
              labelTitle={t('com.label.00095', '담당자')}
              searchWidth="50%"
              searchValueWidth="300px"
              type="input"
              textInputValue={searchParams.soprMgrNm}
              placeholder={t('com.label.00566', '__담당자를 입력하세요')}
              onChange={(e) => {
                handleChangeSearchParams(e, 'soprMgrNm');
              }}
              onKeyUp={(e) => {
                if (e.key === 'Enter') handleClickSearch();
              }}
            />
            <SearchMolecule
              labelTitle={`${t('com.label.00017', '업체명')}(ERP)`}
              searchWidth="50%"
              searchValueWidth="300px"
              type="input"
              textInputValue={searchParams.vdcpErpNm}
              placeholder={t('com.label.00513', '__업체명(ERP)를 입력하세요')}
              onChange={(e) => {
                handleChangeSearchParams(e, 'vdcpErpNm');
              }}
              onKeyUp={(e) => {
                if (e.key === 'Enter') handleClickSearch();
              }}
            />
            <SearchMolecule
              labelTitle={`${t('com.label.00017', '업체명')}(${t('com.label.00514', '거래처')})`}
              searchWidth="50%"
              searchValueWidth="300px"
              type="input"
              textInputValue={searchParams.vdcpNm}
              placeholder={t('com.label.00512', '__업체명(거래처)를 입력하세요')}
              onChange={(e) => {
                handleChangeSearchParams(e, 'vdcpNm');
              }}
              onKeyUp={(e) => {
                if (e.key === 'Enter') handleClickSearch();
              }}
            />
            <SearchMolecule
              labelTitle={t('Vendor ID', 'Vendor ID')}
              searchWidth="50%"
              searchValueWidth="300px"
              type="input"
              textInputValue={searchParams.vdcpCd}
              placeholder={t('com.label.00016', '__Vendor ID를 입력하세요')}
              onChange={(e) => {
                handleChangeSearchParams(e, 'vdcpCd');
              }}
              onKeyUp={(e) => {
                if (e.key === 'Enter') handleClickSearch();
              }}
            />
            <SearchMolecule
              labelTitle={t('com.label.00012', '이름')}
              searchWidth="50%"
              searchValueWidth="300px"
              type="input"
              textInputValue={searchParams.vdcpMgrNm}
              placeholder={t('com.label.00013', '__이름을 입력하세요')}
              onChange={(e) => {
                handleChangeSearchParams(e, 'vdcpMgrNm');
              }}
              onKeyUp={(e) => {
                if (e.key === 'Enter') handleClickSearch();
              }}
            />
            <SearchMolecule
              labelTitle={t('com.label.00090', '이메일')}
              searchWidth="50%"
              searchValueWidth="300px"
              type="input"
              textInputValue={searchParams.vdcpMgrEmal}
              placeholder={t('com.label.00800', '__이메일을 입력하세요')}
              onChange={(e) => {
                handleChangeSearchParams(e, 'vdcpMgrEmal');
              }}
              onKeyUp={(e) => {
                if (e.key === 'Enter') handleClickSearch();
              }}
            />
            <SearchMolecule
              labelTitle={t('com.label.00096', '법인코드')}
              searchWidth="50%"
              searchValueWidth="300px"
              type="input"
              textInputValue={searchParams.soprMgrCopCd}
              placeholder={t('com.label.00801', '__법인코드를 입력하세요')}
              onChange={(e) => {
                handleChangeSearchParams(e, 'soprMgrCopCd');
              }}
              onKeyUp={(e) => {
                if (e.key === 'Enter') handleClickSearch();
              }}
            />
            <SearchMolecule
              type="calendar"
              labelTitle={t('com.label.reqDtm', '__요청일시')}
              calendarDouble={true}
              calendarFormat="YYYY.MM.DD"
              calendarViews={['year', 'month', 'day']}
              calendarMaxWidth="128px"
              startDate={dayjs(searchParams.regReqDtSt)}
              endDate={dayjs(searchParams.regReqDtEnd)}
              onChange={handleCrtDateChange}
              mindate={'2001.01.01'}
              maxdate={`${String(Number(new Date().getFullYear()) + 20)}.01.01`}
            />
          </SearchItemWrap>
          <GButtonLayout marginBottom="0px">
            <GButtonBoxCum>
              <GButton
                chkImg={RecycleB}
                sizes="medium"
                btnstyled="outline"
                btnColor="normal"
                hasImg={true}
                hasTxt={false}
                onClick={handleClickSearchParamInit}
              ></GButton>
              <GButton
                chkImg={searchImage}
                txt={t('com.label.00116', '조회')}
                sizes="medium"
                btnstyled="contained"
                btnColor="normal"
                hasImg={true}
                hasTxt={true}
                onClick={handleClickSearch}
              ></GButton>
            </GButtonBoxCum>
          </GButtonLayout>
        </UnHiddenSearchWrap>
      </SearchWrap>

      <SubTitleBtnArea>
        <SubTitleBox
          content={t('com.label.00423', '__회원가입 신청 목록')}
          showSubTitle={true}
          isVisibleComment={false}
          isVisibleInfo={false}
          isVisbleSum={true}
          isVisbleSelect={true}
          commentCount={totalCount}
          selectOption={pageSizeList}
          defaultOption={pageSizeOption}
          onChange={handlePageSize}
        />
      </SubTitleBtnArea>
      {/* style에 flex: 1 삭제하고  높이 지정하면 특정 높이로 수정은 가능함 */}
      <GContentGrid
        type="none"
        className="ag-theme-alpine"
        style={{ marginBottom: '8px', height: 'calc(100vh - 425px)' }}
        isSortable={false}
        isPagination={true}
      >
        <AgGridReact
          defaultColDef={defaultColDef}
          columnDefs={colDefs}
          rowData={memberList}
          rowSelection={'single'}
          enableCellTextSelection
          onGridReady={(params) => (gridApiRef.current = params.api)}
          tooltipShowDelay={0}
          onCellClicked={(e: CellClickedEvent) => {
            navigate('/member/detail', {
              state: { vdcpCd: e.data.vdcpCd, pageNo, pageSize, searchParams },
            });
          }}
          noRowsOverlayComponent={EmptyState}
          noRowsOverlayComponentParams={{ type: 'grid' }}
        />
        {memberList && memberList.length !== 0 && (
          <GPagination
            ref={paginationRef}
            totalCount={totalCount}
            defaultPageNo={pageNo}
            defaultPageSize={pageSize}
            onChangePageSize={handlePageSize}
            onClickPageNo={handlePageNoClick}
          />
        )}
      </GContentGrid>

      {noticePopups
        ?.filter((item) => item.bbmClsfCd === 'EMPLOYEE')
        .map((notice) => {
          return (
            <NoticeModal
              key={notice.bbmNo}
              bbmNo={notice.bbmNo}
              bbmTitNm={notice.bbmTitNm}
              bbmCtn={notice.bbmCtn}
              poupEpsNuseDdn={Number(notice.poupEpsNuseDdn)}
              atchFileGrId={notice.atchFileGrId}
            />
          );
        })}
    </>
  );
};

export default MemberListPage;
